export default {
  check_status: {
    verified: 'Zweryfikowano',
    pending: 'Oczekuje',
    failed: 'Niepowodzenie',
    not_applicable: 'Niewymagane',
    required: 'Wymagane',
  },
  records: {
    type: 'Typ',
    name: 'Nazwa',
    value: 'Wartość',
    status: 'Status',
    certificate: 'Certyfikat',
    certificate_hint: 'Wystawiany automatycznie po znalezieniu powyższych rekordów.',
    full_name: 'Pełna nazwa:',
  },
  check_hint: {
    found: 'Zamiast tego znaleziono {{values}}. Należy zastąpić go wyświetloną wartością.',
    missing: 'Nie znaleziono tego rekordu.',
    certificate: 'Nie udało się wystawić certyfikatu. Należy poprawić oznaczone powyżej rekordy i sprawdzić ponownie.',
    certificate_unknown:
      'Nie udało się wystawić certyfikatu. Należy sprawdzić ponownie później, a jeśli nic się nie zmieni, skontaktować się z pomocą techniczną.',
    regressed: 'Ten rekord był wcześniej zweryfikowany i nie jest już znajdowany.',
    technical: 'Szczegóły techniczne: {{error}}',
    held_by_another_project:
      '{{name}} jest używana przez inną stronę internetową w Vercel, więc nie może przekierowywać odwiedzających do sklepu pod adresem www.{{name}}. Aby {{name}} również otwierała sklep, należy najpierw usunąć domenę z tamtej strony.',
    certificate_pending: {
      not_attached: 'W toku: domena jest dodawana po naszej stronie.',
      awaiting_dns: 'W toku: certyfikat zostanie wystawiony po znalezieniu powyższych rekordów.',
      awaiting_certificate:
        'W toku: rekordy wskazują na nas, a certyfikat jest wystawiany. Zwykle trwa to kilka minut.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} jest też połączona z innym kontem Vercel. Aby potwierdzić własność domeny, należy dodać również poniższe rekordy TXT u dostawcy DNS i sprawdzić ponownie.',
      held_by_another_project:
        'Inna strona internetowa w Vercel już używa {{name}}. Należy najpierw usunąć domenę z tamtej strony i sprawdzić ponownie albo użyć innej domeny.',
      dns_correct_but_unconfigured:
        'Powyższe rekordy są poprawne, ale coś innego w {{name}} blokuje certyfikat. Należy usunąć wszystkie rekordy AAAA dla tej nazwy, wyłączyć serwer proxy przed nią (np. pomarańczową chmurę w Cloudflare) i upewnić się, że żaden rekord CAA nie wyklucza Let’s Encrypt. Następnie należy sprawdzić ponownie.',
      name_mismatch:
        '{{name}} odpowiada certyfikatem dla {{names}}. Należy upewnić się, że powyższe rekordy są jedynymi dla {{name}}; jeśli tak, należy skontaktować się z pomocą techniczną.',
      name_mismatch_unnamed:
        '{{name}} odpowiada certyfikatem dla innej nazwy. Należy upewnić się, że powyższe rekordy są jedynymi dla {{name}}; jeśli tak, należy skontaktować się z pomocą techniczną.',
      expired:
        'Certyfikat wygasł i nie został odnowiony. Otrzymaliśmy powiadomienie i zajmujemy się tym — na razie nic nie trzeba robić.',
      expiring:
        'Certyfikat wkrótce wygaśnie i nie został jeszcze odnowiony. Zajmujemy się tym — na razie nic nie trzeba robić.',
      attach_refused:
        'Nasz dostawca hostingu odmówił dodania {{name}} po naszej stronie. Zostaliśmy powiadomieni i sprawdzamy to — na razie nie trzeba nic zmieniać u dostawcy DNS.',
    },
    certificate_overdue: {
      not_attached:
        'Po 48 godzinach nadal nie udało się dodać domeny po naszej stronie. Należy skontaktować się z pomocą techniczną.',
      awaiting_dns:
        'Po 48 godzinach nadal oczekuje na powyższe rekordy. Należy poprawić oznaczone powyżej rekordy i sprawdzić ponownie.',
      awaiting_dns_records_verified:
        'Nadal nie wystawiono po 48 godzinach, choć powyższe rekordy są zweryfikowane. Należy skontaktować się z pomocą techniczną.',
      awaiting_certificate:
        'Rekordy wskazują na nas, ale certyfikat nadal nie został wystawiony po 48 godzinach. Należy skontaktować się z pomocą techniczną.',
    },
    certificate_dates: {
      valid_until: 'Ważny do {{date}}.',
      expires_on: 'Wygasa {{date}}.',
      expired_on: 'Wygasł {{date}}.',
    },
  },
};
